// extracted by mini-css-extract-plugin
export default {"prompt":"ModuleName-moduleprompt-o3MC0"};